import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';
import Text from '@rsos/components/capstone/base/Text';

export const DisclaimerBannerContainer = styled(Box).attrs({
  bg: 'lightWarning',
  p: 15,
  m: 15,
  mt: 0,
  borderRadius: '5px',
})``;

export const DisclaimerBannerText = styled(Text).attrs({
  color: 'lightWarningText',
  size: 'small',
})``;
